<template>
  <div class="outline-box">
    <a-collapse v-model="outlineState.activeKey" :bordered="false">
      <a-collapse-panel
        :show-arrow="false"
        v-for="e in outlineList"
        :key="e.id"
      >
        <template #header>
          <p style="font-weight: 600">{{ e.chapterName }}</p>
        </template>
        <a-collapse
          v-model="outlineState.subActiveKey"
          :bordered="false"
          class="courseware-chapter-box"
        >
          <a-collapse-panel
            :show-arrow="false"
            v-for="el in e.children"
            :key="el.id"
          >
            <template #header>
              <p><img src="@/assets/img/sjxicon.png" />{{ el.chapterName }}</p>
            </template>

            <a-collapse
              v-model="outlineState.nodeActiveKey"
              :bordered="false"
              class="courseware-chapter-box"
            >
              <a-collapse-panel
                v-for="j in el.children"
                :key="j.id"
                :show-arrow="false"
              >
                <template #header>
                  <p>
                    <img src="@/assets/img/yqicon.png" />{{ j.chapterName }}
                  </p>
                </template>
                <template v-if="j.contentList && j.contentList.length > 0">
                  <p
                    v-for="item in j.contentList"
                    :key="item.id"
                    @click="$emit('selectBrowseCourse', item)"
                    :class="{ active: selectCourseId === item.id }"
                  >
                    <VIconFont :type="courseIcon[item.attmType].icon" />
                    {{ courseIcon[item.attmType].title }}：{{ item.attmName }}
                  </p>
                </template>
              </a-collapse-panel>
            </a-collapse>
            <template v-if="el.contentList && el.contentList.length > 0">
              <p
                v-for="item in el.contentList"
                :key="item.id"
                @click="$emit('selectBrowseCourse', item)"
                :class="{ active: selectCourseId === item.id }"
              >
                <VIconFont :type="courseIcon[item.attmType].icon" />
                {{ courseIcon[item.attmType].title }}：{{ item.attmName }}
              </p>
            </template>
          </a-collapse-panel>
        </a-collapse>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import { courseChapterTree } from "@/api/activity";
import VIconFont from "@/components/iconFont.vue";
import { mapGetters } from "vuex";

export default {
  props: ["selectCourseId", "distributeWay"],
  components: {
    VIconFont,
  },
  data() {
    return {
      courseStudentId: "",
      courseIcon: [
        {},
        { icon: "icon-doc", title: "文档" },
        { icon: "icon-tupian", title: "图片" },
        { icon: "icon-shipin_n", title: "视频" },
        { icon: "icon-yinpin", title: "音频" },
        { icon: "icon-ziyuan", title: "资源" },
        { icon: "icon-pdf", title: "pdf" },
        { icon: "icon-ppt", title: "ppt" },
      ],
      outlineState: {
        activeKey: [],
        subActiveKey: [],
        nodeActiveKey: [],
      },
      outlineList: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    courseId: function () {
      return this.$route.query.courseId;
    },
  },
  mounted() {
    this.courseStudentId = this.userInfo.id;
    this.loadOutline();
  },
  methods: {
    async loadOutline() {
      const res = await courseChapterTree({ courseId: this.courseId });

      this.outlineList = res;
      if (res.length > 0) {
        res.forEach((element) => {
          this.outlineState.activeKey.push(element.id);
        });
      }
      if (res[0].children[0].children.length > 0) {
        this.outlineState.subActiveKey.push(res[0].children[0].id);
        if (res[0].children[0].children[0].contentList.length > 0) {
          this.outlineState.nodeActiveKey.push(
            res[0].children[0].children[0].id
          );
          this.$emit(
            "selectBrowseCourse",
            res[0].children[0].children[0].contentList[0]
          );
        }
      } else if (res[0].children[0].contentList) {
        this.outlineState.subActiveKey.push(res[0].children[0].id);
        this.$emit("selectBrowseCourse", res[0].children[0].contentList[0]);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.outline-box {
  height: 100%;
  ::v-deep .ant-collapse {
    background: transparent;
    > .ant-collapse-item {
      border-bottom: 0;
    }
  }
  ::v-deep .ant-collapse-header {
    padding: 13px 24px;
    font-size: 14px;
    color: #323233;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep .ant-collapse-content-box {
    padding: 0;
  }
  .courseware-chapter-box {
    ::v-deep .ant-collapse-header {
      padding: 9px 24px;
      > p {
        display: flex;
        align-items: center;
        > img {
          margin-right: 6px;
          transition: all 0.3s;
        }
      }
    }
    ::v-deep .ant-collapse-item-active {
      .ant-collapse-header {
        > p {
          > img {
            transform: rotate(90deg);
          }
        }
      }
    }
    ::v-deep .ant-collapse-content-box {
      > p {
        padding: 0 24px 0 38px;
        height: 32px;
        // display: flex;
        // align-items: center;
        line-height: 32px;
        font-size: 12px;
        color: #969799;
        transition: all 0.3s;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        > span {
          float: left;
          transition: all 0.3s;
          margin-right: 6px;
          margin-top: 10px;
          color: #c9d0d6;
        }
        &:hover {
          background: #f9fafe;
          color: #ff7c15;
          > span {
            color: #ff7c15;
          }
        }
        &.active {
          background: #f9fafe;
          color: #ff7c15;
          > span {
            color: #ff7c15;
          }
        }
      }
    }
    .courseware-chapter-box {
      ::v-deep .ant-collapse-header {
        padding: 9px 38px;
      }
      ::v-deep .ant-collapse-content-box {
        > p {
          padding: 0 24px 0 52px;
        }
      }
    }
  }
}
</style>
